(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[451],{

/***/ 35060:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/karfa",
      function () {
        return __webpack_require__(95120);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ PageContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20929);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49012);



var PageContent = function(param) {
    var children = param.children, _title = param.title, title = _title === void 0 ? src_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.title */ .D.title : _title, label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout__WEBPACK_IMPORTED_MODULE_2__/* .PageContainer */ ._z, {
        title: "".concat(label, " - ").concat(title),
        children: children
    });
};


/***/ }),

/***/ 39884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ PageContent/* PageContent */.J; },
  "S": function() { return /* reexport */ PageLoading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(20929);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
// EXTERNAL MODULE: ./src/components/genericPage/PageContent.tsx
var PageContent = __webpack_require__(70857);
;// CONCATENATED MODULE: ./src/components/genericPage/PageLoading.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 80vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LOADING_LABEL = "S\xe6ki \u2026";
var LoaderWrapper = styled_components_browser_esm["default"].div(_templateObject());
var PageLoading = function(param) {
    var _title = param.title, title = _title === void 0 ? config/* Config.title */.D.title : _title, _loadingLabel = param.loadingLabel, loadingLabel = _loadingLabel === void 0 ? LOADING_LABEL : _loadingLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContent/* PageContent */.J, {
        label: loadingLabel,
        title: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {})
        })
    });
};

;// CONCATENATED MODULE: ./src/components/genericPage/index.ts




/***/ }),

/***/ 20929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Config; }
/* harmony export */ });
var Config = {
    title: "Rekstrarv\xf6rur"
};


/***/ }),

/***/ 95120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Karfa; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/remixicon-react/CloseLineIcon.js
var CloseLineIcon = __webpack_require__(46550);
var CloseLineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseLineIcon);
// EXTERNAL MODULE: ./src/utils/numbers.ts
var numbers = __webpack_require__(60165);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
// EXTERNAL MODULE: ./src/components/common/Loader.tsx
var Loader = __webpack_require__(965);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./src/components/cart/CartOverview.tsx
var CartOverview = __webpack_require__(28027);
// EXTERNAL MODULE: ./src/components/layout/PageContainer.tsx + 4 modules
var PageContainer = __webpack_require__(78823);
// EXTERNAL MODULE: ./src/context/CheckoutContext/index.tsx + 15 modules
var CheckoutContext = __webpack_require__(86771);
// EXTERNAL MODULE: ./src/components/common/Modal.tsx + 32 modules
var Modal = __webpack_require__(92627);
;// CONCATENATED MODULE: ./src/components/cart/EmptyCartButton.tsx







function EmptyCartButton() {
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var clearCart = (0,CheckoutContext/* useCheckout */.Mg)().clearCart;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* UnderlineButton */.tg, {
                text: "Ey\xf0a \xf6llu \xfar k\xf6rfu",
                onClick: function() {
                    return setShow(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: show,
                setShow: setShow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H5, {
                        withGutter: true,
                        children: "Ertu viss um a\xf0 \xfe\xfa viljir ey\xf0a \xf6llum v\xf6rum \xfar k\xf6rfunni?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                        color: "black60",
                        withGutter: true,
                        children: "\xde\xfa munt ekki geta teki\xf0 \xfeessa a\xf0ger\xf0 til baka."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                sm: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                                    onClick: function() {
                                        return setShow(false);
                                    },
                                    children: "H\xe6tta vi\xf0"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                sm: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                                    outlined: true,
                                    onClick: function() {
                                        clearCart();
                                        setShow(false);
                                    },
                                    children: "Ey\xf0a \xf6llu"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/remixicon-react/DeleteBinLineIcon.js
var DeleteBinLineIcon = __webpack_require__(39285);
var DeleteBinLineIcon_default = /*#__PURE__*/__webpack_require__.n(DeleteBinLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowGoBackLineIcon.js
var ArrowGoBackLineIcon = __webpack_require__(34619);
var ArrowGoBackLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowGoBackLineIcon);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
// EXTERNAL MODULE: ./src/utils/isTouch.ts
var isTouch = __webpack_require__(20619);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/utils/getMediaDataVariants.ts
var typeIsMetaDataItem = function(value) {
    return typeof value === "object" && value !== null && "key" in value && value.key != null;
};
var ref;
var getMediaDataVariants = function(metadata) {
    return (ref = (metadata || []).filter(typeIsMetaDataItem).find(function(param) {
        var key = param.key;
        return key === "unit_types";
    })) !== null && ref !== void 0 ? ref : {};
};

// EXTERNAL MODULE: ./src/components/products/ProductCard/utils/getVariant.ts
var getVariant = __webpack_require__(44940);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/utils/toVariantObject.ts
var _id, _min_qty, _qty_per_unit, toVariantObject_ref, ref1, _name_plural, _name_singular;
var toVariantObject = function(value) {
    var ref3, ref2;
    return {
        id: (_id = value.id) !== null && _id !== void 0 ? _id : null,
        min_qty: parseFloat((_min_qty = value.min_qty) !== null && _min_qty !== void 0 ? _min_qty : "0"),
        qty_per_unit: parseFloat((_qty_per_unit = value.qty_per_unit) !== null && _qty_per_unit !== void 0 ? _qty_per_unit : "0"),
        prices: {
            gross: parseFloat((toVariantObject_ref = (ref3 = value.price) === null || ref3 === void 0 ? void 0 : ref3.gross) !== null && toVariantObject_ref !== void 0 ? toVariantObject_ref : "0"),
            net: parseFloat((ref1 = (ref2 = value.price) === null || ref2 === void 0 ? void 0 : ref2.net) !== null && ref1 !== void 0 ? ref1 : "0")
        },
        name_plural: (_name_plural = value.name_plural) !== null && _name_plural !== void 0 ? _name_plural : null,
        name_singular: (_name_singular = value.name_singular) !== null && _name_singular !== void 0 ? _name_singular : null
    };
};

;// CONCATENATED MODULE: ./src/components/products/ProductCard/utils/getMediaDataVariantObjects.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var getMediaDataVariantObjects = function(metadata) {
    try {
        var json = metadata.value;
        var value = json ? JSON.parse(json) : {};
        return Object.keys(value).reduce(function(obj, item) {
            return _objectSpread({}, obj, _defineProperty({}, item, toVariantObject(value[item])));
        }, {});
    } catch (_e) {
        return null;
    }
};

// EXTERNAL MODULE: ./src/components/products/ProductCartPicker/interfaces.ts
var interfaces = __webpack_require__(64474);
// EXTERNAL MODULE: ./src/utils/checkout.ts + 1 modules
var checkout = __webpack_require__(97688);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/form/index.tsx + 3 modules
var components_form = __webpack_require__(27618);
// EXTERNAL MODULE: ./node_modules/use-debounce/esm/useDebouncedCallback.js
var useDebouncedCallback = __webpack_require__(19302);
// EXTERNAL MODULE: ./src/context/CheckoutContext/checkout-event.ts
var checkout_event = __webpack_require__(67952);
;// CONCATENATED MODULE: ./src/components/cart/CheckoutLineCard/store.ts

var CurrentQuantityItem = (0,recoil/* atomFamily */.xu)({
    key: "current-quantity-item",
    default: 1
});

;// CONCATENATED MODULE: ./src/components/cart/CheckoutLineCard/CheckoutLineVariant.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CheckoutLineVariant_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-right: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var ButtonWrapper = styled_components_browser_esm["default"].div(_templateObject());
var ButtonLabel = (0,styled_components_browser_esm["default"])(typography/* PSmall */.zK)(_templateObject1());
var DEBOUNCE_TIME_MS = 800;
var CheckoutLineVariant = function(param) {
    var item = param.item, qty = param.qty, variantId = param.variantId;
    var cartUpdate = (0,CheckoutContext/* useCheckout */.Mg)().cartUpdate;
    var ref = (0,react.useState)(item.quantity), currentQty = ref[0], setCurrentQty = ref[1];
    var ref1 = _slicedToArray((0,recoil/* useRecoilState */.FV)(CurrentQuantityItem(variantId)), 2), _ = ref1[0], setAllQuantity = ref1[1];
    (0,react.useEffect)(function() {
        setCurrentQty(item.quantity);
    }, [
        item.quantity
    ]);
    var handleUpdateHelper = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(value) {
            var base;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        base = qty ? qty - item.quantity * item.qty_per_unit : 0;
                        if (!(base === 0 && value === 0)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return cartUpdate(CheckoutLineVariant_defineProperty({}, variantId, base + value * item.qty_per_unit));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cartUpdate,
        item.qty_per_unit,
        item.quantity,
        qty,
        variantId
    ]);
    var handleUpdateHelperDebounced = (0,useDebouncedCallback/* default */.Z)(handleUpdateHelper, DEBOUNCE_TIME_MS);
    var handleUpdate = (0,react.useCallback)(function(value) {
        if (checkout_event/* CheckoutEventChange */.Z) {
            document.body.dispatchEvent(checkout_event/* CheckoutEventChange */.Z);
        }
        setCurrentQty(value);
        var base = qty ? qty - item.quantity * item.qty_per_unit : 0;
        setAllQuantity(base + value * item.qty_per_unit);
        handleUpdateHelperDebounced(value);
    }, [
        handleUpdateHelperDebounced,
        item.qty_per_unit,
        item.quantity,
        qty,
        setAllQuantity, 
    ]);
    var isMin = item.quantity === 1 && qty === item.qty_per_unit || item.quantity === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLabel, {
                color: "black60",
                children: [
                    item.name_singular.charAt(0).toUpperCase() + item.name_singular.slice(1),
                    item.qty_per_unit !== 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "(",
                            item.qty_per_unit,
                            " stykki)"
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* QtyPicker */.bF, {
                isMin: isMin,
                qty: currentQty,
                isDisabled: false,
                onUpdate: handleUpdate
            }),
            " "
        ]
    });
};

// EXTERNAL MODULE: ./src/api/saleor/generated/index.tsx
var generated = __webpack_require__(49554);
;// CONCATENATED MODULE: ./src/components/cart/CheckoutLineCard/hooks/useProduct.tsx

var useProduct = function(param) {
    var line = param.line;
    return (0,generated/* useProductQuery */.FA3)({
        variables: {
            slug: line.variant.product.slug
        },
        skip: !line.variant.product.slug
    });
};

;// CONCATENATED MODULE: ./src/components/cart/CheckoutLineCard/CheckoutLineVariants.tsx
function CheckoutLineVariants_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return CheckoutLineVariants_arrayLikeToArray(arr);
}
function CheckoutLineVariants_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CheckoutLineVariants_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CheckoutLineVariants_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CheckoutLineVariants_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || CheckoutLineVariants_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function CheckoutLineVariants_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CheckoutLineVariants_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CheckoutLineVariants_arrayLikeToArray(o, minLen);
}
function CheckoutLineVariants_templateObject() {
    var data = CheckoutLineVariants_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    CheckoutLineVariants_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Wrapper = styled_components_browser_esm["default"].ul(CheckoutLineVariants_templateObject());
var CheckoutLineVariants = function(param) {
    var line = param.line, qty = param.qty, variantId = param.variantId;
    var ref3;
    var ref1 = useProduct({
        line: line
    }), error = ref1.error, loading = ref1.loading, data = ref1.data;
    var items = (0,react.useMemo)(function() {
        var ref, ref2;
        if (error || loading || !(data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.variants)) {
            return [];
        }
        var variants = data.product.variants ? getMediaDataVariants((ref2 = (0,getVariant/* getVariant */.b)(data.product.variants)()) === null || ref2 === void 0 ? void 0 : ref2.metadata) : {};
        var objects = getMediaDataVariantObjects(variants) || {};
        var mappedObject = Object.keys(objects).map(function(key) {
            return CheckoutLineVariants_objectSpread({}, objects[key], {
                id: objects[key].id || interfaces/* ProductTypePiece */.Ji
            });
        }).sort(function(a, b) {
            return b.qty_per_unit - a.qty_per_unit;
        });
        var boxes = mappedObject.map(function(item) {
            return [
                item.id,
                item.qty_per_unit
            ];
        });
        if (boxes.length === 0 || qty === 0) {
            return [];
        }
        if (qty == null) {
            return [];
        }
        var allocate = (0,checkout/* allocateItemsToBoxes */.jv)(qty, boxes);
        var _id;
        return mappedObject.map(function(item) {
            return CheckoutLineVariants_objectSpread({}, item, {
                quantity: (_id = allocate[item.id]) !== null && _id !== void 0 ? _id : 0
            });
        });
    }, [
        data === null || data === void 0 ? void 0 : (ref3 = data.product) === null || ref3 === void 0 ? void 0 : ref3.variants,
        error,
        loading,
        qty
    ]);
    if (loading) {
        // TODO: Loading screen
        return null;
    }
    if (error) {
        // TODO: Error screen
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            children: _toConsumableArray(items).reverse().map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutLineVariant, {
                    item: item,
                    qty: qty,
                    variantId: variantId
                }, item.id);
            })
        })
    });
};

// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(27827);
;// CONCATENATED MODULE: ./src/components/cart/CheckoutLineCard/CheckoutLineCard.tsx
function CheckoutLineCard_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CheckoutLineCard_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function CheckoutLineCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CheckoutLineCard_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function CheckoutLineCard_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CheckoutLineCard_slicedToArray(arr, i) {
    return CheckoutLineCard_arrayWithHoles(arr) || CheckoutLineCard_iterableToArrayLimit(arr, i) || CheckoutLineCard_unsupportedIterableToArray(arr, i) || CheckoutLineCard_nonIterableRest();
}
function CheckoutLineCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CheckoutLineCard_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CheckoutLineCard_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CheckoutLineCard_arrayLikeToArray(o, minLen);
}
function CheckoutLineCard_templateObject() {
    var data = CheckoutLineCard_taggedTemplateLiteral([
        "\n  position: relative;\n  margin-bottom: 24px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 20px;\n"
    ]);
    CheckoutLineCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckoutLineCard_templateObject1() {
    var data = CheckoutLineCard_taggedTemplateLiteral([
        ""
    ]);
    CheckoutLineCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = CheckoutLineCard_taggedTemplateLiteral([
        "\n    margin-top: 15px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = CheckoutLineCard_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = CheckoutLineCard_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = CheckoutLineCard_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-left: 111px;\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    margin-left: 0;\n    margin-top: 20px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = CheckoutLineCard_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = CheckoutLineCard_taggedTemplateLiteral([
        "\n  width: fit-content;\n  margin-right: 10px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = CheckoutLineCard_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: ",
        ";\n  align-items: center;\n  justify-content: center;\n  z-index: 99;\n  opacity: 0.9;\n  background-color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = CheckoutLineCard_taggedTemplateLiteral([
        "\n  top: 1px;\n  right: 1px;\n  opacity: ",
        ";\n  transition: opacity 0.15s;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

/* eslint-disable no-nested-ternary */ 
















var LineCard = styled_components_browser_esm["default"].div(CheckoutLineCard_templateObject(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("black"));
var CardWrapper = styled_components_browser_esm["default"].div(CheckoutLineCard_templateObject1());
var ProductInfo = (0,styled_components_browser_esm["default"])(common/* Link */.rU)(_templateObject3(), dist.media.sm(_templateObject2()));
var ProductInfoText = styled_components_browser_esm["default"].div(_templateObject4());
var ProductVariant = styled_components_browser_esm["default"].div(_templateObject5(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var QtyPriceWrapper = styled_components_browser_esm["default"].div(_templateObject6(), (0,es/* palette */.DG)("black90"));
var PriceWrapper = styled_components_browser_esm["default"].div(_templateObject7());
var DeleteBackground = styled_components_browser_esm["default"].div(_templateObject8(), (0,es/* ifProp */.fq)({
    show: true
}, "flex", "none"), (0,es/* palette */.DG)("background"));
var DeleteButton = (0,styled_components_browser_esm["default"])(buttons/* CornerButton */.gm)(_templateObject9(), function(param) {
    var hover = param.hover;
    return isTouch/* isTouchDevice */.b ? 1 : hover ? 1 : 0;
});
var CheckoutLineCard = function(param) {
    var line = param.line;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var ref16 = (0,react.useState)(false), remove = ref16[0], setRemove = ref16[1];
    var ref17 = (0,react.useState)(false), hover = ref17[0], setHover = ref17[1];
    var handleMouseOver = (0,react.useCallback)(function() {
        return setHover(true);
    }, []);
    var handleMouseOut = (0,react.useCallback)(function() {
        return setHover(false);
    }, []);
    var ref18 = (0,react.useState)(null), timerRemove = ref18[0], setTimerRemove = ref18[1];
    var cartUpdate = (0,CheckoutContext/* useCheckout */.Mg)().cartUpdate;
    var variantId = line.variant.id;
    var ref19 = CheckoutLineCard_slicedToArray((0,recoil/* useRecoilState */.FV)(CurrentQuantityItem(variantId)), 2), inputQuantity = ref19[0], setInputQuantity = ref19[1];
    (0,react.useEffect)(function() {
        setInputQuantity(line.quantity);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        line.quantity
    ]);
    (0,react.useEffect)(function() {
        var fn = function() {
            setInputQuantity(line.quantity);
        };
        document.body.addEventListener("CheckoutError", fn);
        return function() {
            document.body.removeEventListener("CheckoutError", fn);
        };
    }, [
        line.quantity,
        setInputQuantity
    ]);
    var currentQty = inputQuantity;
    var image = (line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.media) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.url) || (line === null || line === void 0 ? void 0 : (ref3 = line.variant) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.media) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.url);
    var handleDeleteLine = (0,react.useCallback)(function() {
        if (!remove) {
            setRemove(true);
            setTimerRemove(window.setTimeout(function() {
                return cartUpdate(CheckoutLineCard_defineProperty({}, variantId, 0));
            }, 2000));
        } else {
            setRemove(false);
            if (timerRemove) {
                window.clearTimeout(timerRemove);
            }
        }
    }, [
        cartUpdate,
        remove,
        timerRemove,
        variantId
    ]);
    var ref20;
    var price = (ref20 = line === null || line === void 0 ? void 0 : (ref7 = line.totalPrice) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.gross) === null || ref8 === void 0 ? void 0 : ref8.amount) !== null && ref20 !== void 0 ? ref20 : null;
    var perUnitPrice = price && currentQty ? price / currentQty : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineCard, {
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfo, {
                        href: (0,paths/* generatePath */.G)(paths/* paths.product */.H.product, line === null || line === void 0 ? void 0 : (ref9 = line.variant) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.product) === null || ref10 === void 0 ? void 0 : ref10.slug),
                        children: [
                            image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
                                src: image,
                                alt: line === null || line === void 0 ? void 0 : (ref11 = line.variant) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.product) === null || ref12 === void 0 ? void 0 : ref12.name,
                                width: 100,
                                height: 80,
                                layout: "responsive",
                                objectFit: "contain"
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfoText, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                        color: "black60",
                                        children: line === null || line === void 0 ? void 0 : (ref13 = line.variant) === null || ref13 === void 0 ? void 0 : ref13.sku
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PLarge */.cG, {
                                        bold: true,
                                        children: line === null || line === void 0 ? void 0 : (ref14 = line.variant) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.product) === null || ref15 === void 0 ? void 0 : ref15.name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductVariant, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutLineVariants, {
                                line: line,
                                qty: currentQty,
                                variantId: variantId
                            }),
                            price && perUnitPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                        color: "black60",
                                        children: "Samtals"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.H5, {
                                        children: [
                                            (0,numbers/* formatNumber */.uf)(perUnitPrice * inputQuantity),
                                            " KR."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QtyPriceWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* PSmall */.zK, {
                                                children: [
                                                    (0,numbers/* formatNumber */.uf)(inputQuantity),
                                                    " stykki"
                                                ]
                                            }),
                                            " /",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* PSmall */.zK, {
                                                children: [
                                                    (0,numbers/* formatNumber */.uf)(perUnitPrice),
                                                    " kr. /stk."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteBackground, {
                show: remove,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* UnderlineButton */.tg, {
                    text: "Draga a\xf0ger\xf0 til baka",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowGoBackLineIcon_default()), {
                        size: 14
                    }),
                    onClick: handleDeleteLine
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteButton, {
                hover: hover,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((DeleteBinLineIcon_default()), {
                    size: 16
                }),
                onClick: handleDeleteLine
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/cart/CheckoutLineCard/index.ts


// EXTERNAL MODULE: ./src/utils/icelandicQuantity.ts
var icelandicQuantity = __webpack_require__(90844);
// EXTERNAL MODULE: ./src/components/products/index.tsx + 38 modules
var products = __webpack_require__(18254);
// EXTERNAL MODULE: ./src/components/checkout/index.tsx + 21 modules
var components_checkout = __webpack_require__(4126);
// EXTERNAL MODULE: ./src/components/genericPage/index.ts + 1 modules
var genericPage = __webpack_require__(39884);
// EXTERNAL MODULE: ./src/context/UserContext.tsx + 1 modules
var UserContext = __webpack_require__(76336);
// EXTERNAL MODULE: ./src/context/OverlayContext.tsx
var OverlayContext = __webpack_require__(33906);
// EXTERNAL MODULE: ./src/utils/isSSR.ts
var isSSR = __webpack_require__(28095);
// EXTERNAL MODULE: ./src/utils/isNotNull.ts
var isNotNull = __webpack_require__(84403);
;// CONCATENATED MODULE: ./src/pages/karfa.tsx
function karfa_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function karfa_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            karfa_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function karfa_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function karfa_templateObject() {
    var data = karfa_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 38px;\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n"
    ]);
    karfa_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function karfa_templateObject1() {
    var data = karfa_taggedTemplateLiteral([
        "\n\n  \n\n  @media (min-width: ",
        ") {\n    width: 23vw;\n\n    position: ",
        ";\n    top: ",
        ";\n  }\n  .input-container {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 10px;\n    gap: 5px;\n    .submit-button {\n      min-width: 40px;\n    }\n  }\n  .voucher-box {\n    border: 1px solid ",
        ";\n    padding: 10px;\n    width: fit-content;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 10px;\n  }\n\n  @media screen and (max-width: 1500px) {\n    .input-container {\n      flex-direction: column;\n    }\n  @media screen and (max-width: 768px) {\n    .input-container {\n      flex-direction: row;\n    }\n\n"
    ]);
    karfa_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function karfa_templateObject2() {
    var data = karfa_taggedTemplateLiteral([
        ""
    ]);
    karfa_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

/* eslint-disable no-nested-ternary */ 

















// import {CartShipmentPricingAlert} from 'src/components/cart/CartShipmentPricingAlert'








var Divider = styled_components_browser_esm["default"].div(karfa_templateObject(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var OverviewContainer = styled_components_browser_esm["default"].div(karfa_templateObject1(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD, function(props) {
    return props.scrollValue >= props.productHeight - props.cartHeight ? "absolute" : "fixed";
}, function(props) {
    return props.scrollValue >= props.productHeight - props.cartHeight ? "".concat(props.productHeight - props.cartHeight, "px") : "30vh";
}, (0,es/* palette */.DG)("black20"));
var Content = styled_components_browser_esm["default"].div(karfa_templateObject2());
var __N_SSG = true;
function Karfa() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,CheckoutContext/* useCheckout */.Mg)(), checkout = ref4.checkout, checkoutLoading = ref4.checkoutLoading, updateCheckoutVoucher = ref4.updateCheckoutVoucher, removeCheckoutVoucher = ref4.removeCheckoutVoucher;
    var user = (0,UserContext/* useUser */.aF)().user;
    var ref5 = (0,OverlayContext/* useOverlay */.Ir)(), setSideDrawerIsOpen = ref5.setSideDrawerIsOpen, sideDrawerIsOpen = ref5.sideDrawerIsOpen;
    var hasPushedButtonRef = (0,react.useRef)(false);
    var ref6 = (0,react.useState)({
        add: false,
        remove: false
    }), voucherLoad = ref6[0], setVoucherLoad = ref6[1];
    var ref7 = (0,react.useState)(0), scrollValue = ref7[0], setScrollValue = ref7[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var productsRef = (0,react.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var cartRef = (0,react.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    var handleScroll = function() {
        setScrollValue(window.scrollY);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!sideDrawerIsOpen && user && hasPushedButtonRef.current) {
            hasPushedButtonRef.current = false;
            router["default"].push(paths/* paths.checkout */.H.checkout);
        }
    }, [
        sideDrawerIsOpen,
        user
    ]);
    var handleChange = (0,react.useCallback)(function() {
        if (user) {
            router["default"].push(paths/* paths.checkout */.H.checkout);
            return;
        }
        hasPushedButtonRef.current = true;
        setSideDrawerIsOpen(true);
    }, [
        setSideDrawerIsOpen,
        user
    ]);
    if (!isSSR/* isSSR */.y && checkoutLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericPage/* PageLoading */.S, {});
    }
    var handleVoucherSubmit = function(code) {
        setVoucherLoad(karfa_objectSpread({}, voucherLoad, {
            add: true
        }));
        updateCheckoutVoucher(code).then(function() {
            setVoucherLoad(karfa_objectSpread({}, voucherLoad, {
                add: false
            }));
            document.getElementById("voucher-input").value = "";
        });
    };
    var handleVoucherRemove = function(code) {
        setVoucherLoad(karfa_objectSpread({}, voucherLoad, {
            remove: true
        }));
        removeCheckoutVoucher(code).then(function() {
            setVoucherLoad(karfa_objectSpread({}, voucherLoad, {
                remove: false
            }));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContainer/* default */.Z, {
        title: "Karfa",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(products/* Breadcrumbs */.Oo, {
                    breadcrumbs: [
                        {
                            title: "Fors\xed\xf0a",
                            href: paths/* paths.home */.H.home
                        },
                        {
                            title: "Karfan m\xedn",
                            href: paths/* paths.cart */.H.cart
                        }, 
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* SpacingWrapper */.$3, {
                    spacing: 50,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                            title: "Karfan m\xedn"
                        }),
                        !(checkout === null || checkout === void 0 ? void 0 : (ref = checkout.lines) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_checkout/* EmptyCart */.Qd, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Col, {
                                        md: 8,
                                        ref: productsRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Divider, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    (0,icelandicQuantity/* getPluralOrSingular */.e)({
                                                                        plural: "v\xf6rur",
                                                                        singular: "vara",
                                                                        value: checkout.quantity
                                                                    }),
                                                                    " ",
                                                                    "\xed k\xf6rfu"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: " / "
                                                            }),
                                                            ((ref1 = checkout.subtotalPrice) === null || ref1 === void 0 ? void 0 : ref1.gross.amount) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                style: {
                                                                    fontWeight: 600
                                                                },
                                                                children: [
                                                                    (0,numbers/* formatNumber */.uf)(checkout.subtotalPrice.gross.amount),
                                                                    " ",
                                                                    "kr."
                                                                ]
                                                            }) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCartButton, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                                children: ((checkout === null || checkout === void 0 ? void 0 : checkout.lines) || []).filter(isNotNull/* isNotNull */.K).map(function(line) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutLineCard, {
                                                        line: line
                                                    }, line.id);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                        md: 3,
                                        mdOffset: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewContainer, {
                                            cartHeight: (cartRef === null || cartRef === void 0 ? void 0 : (ref2 = cartRef.current) === null || ref2 === void 0 ? void 0 : ref2.offsetHeight) || 0,
                                            productHeight: (productsRef === null || productsRef === void 0 ? void 0 : (ref3 = productsRef.current) === null || ref3 === void 0 ? void 0 : ref3.offsetHeight) || 0,
                                            scrollValue: scrollValue,
                                            ref: cartRef,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "input-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            placeholder: "Voucher Code",
                                                            name: "code",
                                                            id: "voucher-input",
                                                            type: "text",
                                                            style: {
                                                                padding: "10px"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                                                            className: "submit-button",
                                                            onClick: function() {
                                                                var code = document.getElementById("voucher-input").value;
                                                                if (code) {
                                                                    handleVoucherSubmit(code);
                                                                }
                                                            },
                                                            children: !voucherLoad.add ? "Submit" : /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                                        })
                                                    ]
                                                }),
                                                checkout.voucherCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "voucher-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                                            children: checkout.voucherCode
                                                        }),
                                                        voucherLoad.remove ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseLineIcon_default()), {
                                                            onClick: function() {
                                                                if (checkout.voucherCode) handleVoucherRemove(checkout.voucherCode);
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                                                    onClick: handleChange,
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    children: "Ganga fr\xe1 kaupum"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 34619:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowGoBackLineIcon = function ArrowGoBackLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M5.828 7l2.536 2.536L6.95 10.95 2 6l4.95-4.95 1.414 1.414L5.828 5H13a8 8 0 1 1 0 16H4v-2h9a6 6 0 1 0 0-12H5.828z' })
  );
};

var ArrowGoBackLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowGoBackLineIcon) : ArrowGoBackLineIcon;

module.exports = ArrowGoBackLineIcon$1;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [370,724,232,12,823,126,774,888,179], function() { return __webpack_exec__(35060); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);